<template>
  <div class="hello">
   
    <!-- <Top></Top> -->
    <Header></Header>

    <div class="content_s clearfix">
      <Top></Top>
      <div class="content_l ">
        <div class="elter">
          <el-row>
            <el-col>
              <div class="block">
                <el-carousel height="461px" ref="carousel" @click.native="linkTo">
                  <el-carousel-item v-for="(item,index) in carouselData" v-bind:key="index">
                    <img :src="item.img_url" alt="轮播图1">
                    <h3 class="small">{{ item.topic }}</h3>
                  </el-carousel-item>
                </el-carousel>
              </div>

            </el-col>
          </el-row>
        </div>
        <div class="news-list">
          <!-- 小频道CHENNEL -->
          <div ref="theme_top" :class="activeClass ? 'themeTop':''">
            <el-tabs ref="active_name"   v-model="activeName" @tab-click="handleClick">
              <el-tab-pane v-for="(au,index) in chanalsData" :key="index"   :label="au.chennel_name" :name="'chennel_'+au.id" ></el-tab-pane>
            </el-tabs>
          </div>

          <!-- 首页文章推荐/文章展示专区 -->
          <el-row >
            <div v-for="(index,num) in articalData" :key="num">
              <el-col :span="6"   ref="col_article" @click.native="toArtical(index._uniquecode)" >
                <el-card :body-style="{ padding: '0px'}">
                  <div class="new-img">
                    <div class="jian-tip" v-if="num <=7">热</div>
                    <img :src="index.thumb_image_url" class="image">
                  </div>

                  <div class="shake">
                    <h3>{{index.title}}</h3>
                    <span class="bq-tip">{{index.chennel_name}}</span>
                  </div>
                </el-card>
              </el-col>

              <!-- 广告部分 -->
              <el-col  v-for="(val,adnum) in advertListDatas" :key="adnum" v-if="num+1 == 4 && adnum ==0">
                <div  style="text-align:center" >
                  <a v-if="val.redirect_url.length > 0" target="_blank" :href="val.redirect_url">
                    <img :src="val.img_url" alt="通栏广告位1" style="width:100%">
                  </a>
                  <img v-if="val.redirect_url.length == 0" :src="val.img_url" alt="通栏广告位1" style="width:100%">
                </div>
              </el-col>

              <el-col v-for="(val,adnum) in advertListDatas" :key="adnum" v-if="num+1 == 16 && adnum ==1">
                <div  style="text-align:center">
                  <a v-if="val.redirect_url.length > 0" target="_blank"  :href="val.redirect_url">
                    <img :src="val.img_url" alt="通栏广告位">
                  </a>
                  <img v-if="val.redirect_url.length == 0" :src="val.img_url" alt="通栏广告位">
                  </div>
              </el-col>

              <el-col v-for="(val,adnum) in advertListDatas" :key="adnum" v-if="num+1 == 24 && adnum ==2">
                <div  style="text-align:center">
                  <a v-if="val.redirect_url.length > 0" target="_blank" :href="val.redirect_url">
                    <img :src="val.img_url" alt="通栏广告位">
                    </a>
                    <img v-if="val.redirect_url.length == 0" :src="val.img_url" alt="通栏广告位">
                  </div>
              </el-col>
            </div>
            <el-empty v-if="articalData.length <=0"   description="暂无更多内容" ></el-empty>
          </el-row>
          <div
           v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
          >
            <el-button 
                type="primary"
                @click="openFullScreen"
                v-if="articalData.length > 0"
                >
              {{downloadMore}}
            </el-button>
          </div>
        </div>
      </div>
      <div class="content_r">
        <el-row>
          <el-col>
            <!-- 大banner 右侧推荐热点活动-->
            <div class="r_topbanner" v-for="(vl,index) in hotActivity" :key="index" v-if="index<2">
              <img :src="vl.thumb_url" alt="活动信息" class="img-1" @click="to_brandActivity(vl.redirect_url)">
            </div>

          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <div class="k-news">
              <h2><i class="el-icon-alarm-clock"></i><span>每日快讯</span><span class="showall_realtime" @click="showRealtimeNews">查看全部</span></h2>
              <div class="k-elter">
                <vue-seamless-scroll 
                :data="listData"
                :class-option="seamlessScrollOption"
                style="
                  height: 400px;
                  overflow: hidden;
                  width: 320px;
                  color: #4b4b4b;
                  font-size: 14px;
                  text-align: center;
              ">
                  <ul>
                    <div v-for="(item, index) in listData" :key="index">
                      <li  style="padding:1px; margin: 1px" v-if="item.origin != undefined">
                        <div class="el-timeline-item__tail"></div>
                        <div class="el-timeline-item__node el-timeline-item__node--normal el-timeline-item__node--"></div>
                        <div class="el-timeline-item__wrapper"></div>
                          <span class="title">
                          <font style="color:#bd2423;"> 【{{ item.article_name}}】 </font>
                          {{item.article_content}} ({{item.origin}} )</span>
                          <span class="date">{{ item.time }}</span>
                      </li>
                    
                      <li style="padding:1px; margin: 1px" v-else>
                        <div class="el-timeline-item__tail"></div>
                        <div class="el-timeline-item__node el-timeline-item__node--normal el-timeline-item__node--"></div>
                        <div class="el-timeline-item__wrapper"></div>
                        <router-link :to="{path:'/realtimedata/artical/'+ item.dates +'/'+item.time}">
                          <span class="title">
                          <font style="color:#bd2423;"> 【{{ item.title}}】 </font>
                          {{item.content}}</span>
                          <span class="date">{{ item.time }}</span>
                        </router-link>
                      </li>
                    </div>
                  </ul>
                </vue-seamless-scroll>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <div class="r-gs1"> 
              <!-- <a href="https://shop44045983.m.youzan.com/wscgoods/detail/2ogmod8y2z593el" target="_blank">
                <img src="http://swapp.iceo.com.cn/Public/images/hd-banner2.jpg" alt="右侧广告">
              </a> -->
              <!-- <br/> -->
              <!-- <a href="https://www.iceo.com.cn/zt/2024_tszg/" target="_blank">
                <img src="https://swapp.iceo.com.cn/Public/images/newsite/2024_tushu.jpg" alt="右侧广告">
              </a> -->

              <!-- <a href="https://shop44045983.m.youzan.com/wscshop/feature/goods/all?kdt_id=43853815" target="_blank">
                <img src="https://swapp.iceo.com.cn/Public/images/newsite/2024-zazhisell.jpg" alt="右侧广告">
              </a> -->
              </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <div class="mag-list">
              <h2><i class="el-icon-reading"></i>最新杂志与报纸</h2>
              <dl>
                <dt>
                  <img v-if="preMagezineinfo.length > 0" :src="'http://iceo-magazine.oss-cn-qingdao.aliyuncs.com'+preMagezineinfo[0].cover" alt="最新杂志" width="100%">
                </dt>
                <dd>
                  <p>【封面报道】</p>
                  <p v-if="preMagezineinfo.length > 0" style="font-size:16px;font-weight:600;color:#4b4b4b">{{preMagezineinfo[0].title}}</p>
                  <p v-if="preMagezineinfo.length > 0" style="margin-top:40px;">年度期号：{{preMagezineinfo[0].issue_number}}</p>
                  <p v-if="preMagezineinfo.length > 0" >总期号：{{preMagezineinfo[0].total_issue_number}}</p>
                  <p v-if="preMagezineinfo.length > 0" >出版：{{preMagezineinfo[0].date}}</p>
                  <button @click="redirectToMagazine"    type="button" class="el-button el-button--default"><span>订阅杂志</span></button>
                </dd>
              </dl>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div class="hotrd-list ">
              <h2><i class="el-icon-connection"></i>热点专题</h2>
              <!-- <div class="hot-list">
                <img src="@/assets/images/zt-01.jpg" alt="热点专题" class="hh-img">
                <i></i>
                <p>复工复产专题</p>
              </div> -->
              <div class="hot-list" @click="redirect_productsite">
                <img src="@/assets/images/zt-02.jpg" alt="热点专题" class="hh-img">
                <i></i>
                <p>专精特新专题</p>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div class="yyy-list">
              <h2><i class="el-icon-s-data"></i>中企研究院</h2>
              <div class="zk-list" v-for="(vl,index) in academy" :key="index" @click="redirect_to_acadamy(vl.uniqueid)">
                <dl>
                  <dt><img :src="vl.avatar_url" :alt="vl.name"></dt>
                  <dd v-if="vl.title">{{vl.title}}</dd>
                </dl>
              </div>

            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <div class="r-gs1"> 
              <img  @click="redirecyToflower"  src="http://swapp.iceo.com.cn/Public/images/hh-dy.jpg" alt="花卉报订阅" class="hh-img">
              </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <div class="pinpai-list">
              <h2><i class="el-icon-trophy"></i>品牌活动</h2>
              <div class="pp-imglist">

                <a target="_blank"   v-for="(vl,index) in brandActivity" :key="index" :href="vl.site_url"><img :src="vl.image_url" :alt="vl.activity_name"></a>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <div class="tougao">
              <img src="@/assets/images/tougao.jpg" alt="投稿">

            </div>
          </el-col>
        </el-row>
        
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
  import Top from "@/components/public/top.vue"
  import Header from "@/components/public/Header.vue"
  import Bottom from "@/components/public/Bottom.vue"
  import Search from "@/components/public/Search.vue"
  export default {
    name: 'Show',
    data() {
      return {
        downloadMore:'加载更多...',
         loading: false,
        serchStatus:false,
        fullscreenLoading: false,
        activeName: 'chennel_1',
        artical_typeid:0,
        hotActivity:[
          {thumb_url:'',redirect_url:''},
          {thumb_url:'',redirect_url:''}
        ],
        startPage:41,
        // 轮播图
        carouselData:[],
        // 小栏目频道
        chanalsData:[],
        // 文章列表
        articalData: [],
        data: ['1', '2', '3', '4'],
        msg: 'shuiahuiah',
        currentDate: new Date(),
        // 研究院
        academy:[],
        // 品牌活动
        brandActivity:[
          {image_url:'http://swapp.iceo.com.cn/Public/images/pp-01.jpg',activity_name:'领袖年会',site_url:'http://www.iceo.com.cn/zt/2025_zgqyj_lxnh/'},
          {image_url:'http://swapp.iceo.com.cn/Public/images/pp-02.jpg',activity_name:'木兰年会',site_url:'http://www.iceo.com.cn/zt/2025_mulannh/'},
          {image_url:'http://swapp.iceo.com.cn/Public/images/pp-03.jpg',activity_name:'未来之星',site_url:'http://www.iceo.com.cn/zt/2024_wlzxnh/'},
          {image_url:'http://swapp.iceo.com.cn/Public/images/pp-04.jpg',activity_name:'专精特新',site_url:'http://www.iceo.com.cn/zt/2022_zhuanjingtexin02/'}
        ],
        advertListDatas:[
          // {img_url:'http://swapp.iceo.com.cn/Public/images/2023-yfkj.jpg',redirect_url:'http://www.iceo.com.cn/article/bcc30d48-c091-4553-93ee-10331a3c4868'},
          // {img_url:'http://swapp.iceo.com.cn/Public/images/pinduoduo1118.jpg',redirect_url:'http://www.iceo.com.cn/article/6ed49b9e-9da5-486b-af82-2a1e882567db'},
          // {img_url:'http://swapp.iceo.com.cn/Public/images/banner_0.jpg',redirect_url:''},
        ],

        // 每日快讯
        listData: [],
        activeClass: 0,
        preMagezineinfo:''
      }
    },

    props: {},

    mounted(){
      window.addEventListener('scroll',this.thmem_move_top)
    },
   
    //页面加载初始化  加载热点推荐的数据
     created(){
      this.getBannerInfo()
      this.getChennelInfo()
      this.getContentInfo()
      this.getHotBannerInfo()
      this.getrealtimeNew()
      this.getRearcherInfo()
      this.getPremagazine()
    },

    //页面属性调用初始化
    computed: {
     
      seamlessScrollOption() {
        return {
          step: 0.3, // 数值越大速度滚动越快
          limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        }
      }

    },

    //页面加载后执行方法
    methods: {

      //获取最新杂志
      getPremagazine(){
        var config = {
          method: 'GET',
          url: '/api/v1/magazine/last',
          headers: { 
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{
          this.preMagezineinfo = res.data
        }).catch(error=>{
          console.log('请求失败')
        })
      },

      getRearcherInfo(){
        var config = {
          method: 'GET',
          url: '/api/v1/researcher/list/pre',
          headers: { 
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{
          this.academy = res.data
        }).catch(error=>{
          console.log('请求失败')
        })
      },
      getrealtimeNew(){

        var config = {
          method: 'GET',
          url: '/api/v1/realtimedata/list',
          headers: { 
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{

          this.listData = res.data
          
        }).catch(error=>{
          console.log('请求失败')
        })


      },
      thmem_move_top(newValue, oldValue) {
        let themeTop = this.$refs.theme_top;
        //浏览器兼容
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

        if (scrollTop > 627) {
          this.$data.activeClass= 1
        }
        else{
            this.$data.activeClass= 0
        }
      
      },

      //获取热点banner数据
      getHotBannerInfo(){

        var config = {
          method: 'GET',
          url: '/api/v1/hotbanner/list',
          headers: { 
              'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{

          this.$data.hotActivity = res.data
          
        }).catch(error=>{
          console.log('请求失败')
        })
      },
      redirect_productsite(){
        window.open('http://www.iceo.com.cn/zt/2022_zhuanjingtexin02/')
      },

      redirecyToflower(){
        window.open('http://www.china-flower.com/')
      },
      redirectToMagazine(){
        this.$router.push({path:'/magazine'})
      },

      to_brandActivity(redirect_url){
          window.open(redirect_url)
      },
      showRealtimeNews(){
        this.$router.push({path:'/realtimelist'})
      },
      // 中企研究院
      redirect_to_acadamy(){
        this.$router.push({path:'/research/academy'})
      },

      // 获取文章主要内容
      getContentInfo(typeid=0){
        if (typeid==1){ 
          typeid=0
        }else{
          this.downloadMore = '加载更多...'
        }
        var config = {
          method: 'GET',
          url: '/api/v1/artical/list/'+typeid,
          headers: { 
              'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{

          this.$data.articalData = res.data
          this.$data.artical_typeid = typeid
          console.log('请求成功')
          
        }).catch(error=>{
          console.log('请求失败')
        })
      },

      getChennelInfo()
      {
          var config = {
            method: 'GET',
            url: '/api/v1/chennel/list',
            headers: { 
                'Content-Type': 'application/json'
            }
          };
            
          this.$axios(config).then(res=>{

            this.$data.chanalsData = res.data
             console.log('请求成功')
          }).catch(error=>{
            console.log('请求失败')
          })

      },

      getBannerInfo() {

         var config = {
          method: 'GET',
          url: '/api/v1/banner/list',
          headers: { 
              'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{

          this.$data.carouselData = res.data
          
        }).catch(error=>{
          console.log('请求失败')
        })


      },

      //页面数据加载更多文章
       openFullScreen() {

        this.$data.loading = true;
        var typeid = this.$data.artical_typeid
        if (typeid==1){ typeid=0}
        var config = {
          method: 'GET',
          url: '/api/v1/artical/list/'+typeid,
          headers: { 
              'Content-Type': 'application/json'
          },
          params:{start_page:this.$data.startPage,loadMore:true}
        };
        
        var artical_length = this.$data.articalData.length
        this.$axios(config).then(res=>{
          
          setTimeout(() => {

              if(res.data.length > 0){
                for(var i=0; i<res.data.length; i++){
                  this.$set(this.articalData, i+artical_length, res.data[i])
                }
                this.startPage = this.$data.startPage + 12
              }else{

                this.downloadMore = '中企君正在添加更多数据...'
              }
            this.$data.loading = false;
            }, 1000);
        }).catch(error=>{
          console.log(error)
          console.log('请求失败')
        })

      },

      //跳转文章页面
      toArtical(_uniquecode){
        var routeInfo = this.$router.resolve({path:'/article/'+_uniquecode});
        window.open(routeInfo.href, '_blank');
      },

      linkTo(){
        let activeIndex = this.$refs.carousel.activeIndex
        this.$router.push({path:this.carouselData[activeIndex].redirect_url})
      },
      
      handleClick(tab, event) {
        var typeid = tab.name.split('_')[1]
        this.getContentInfo( typeid )
      },
      submit_data() {
        // this.$router.push('/collect')
      },

    },
    //组件引入
    components: {
      Top,
      Header,
      Bottom,
      Search
    },
  }

</script>

<style scoped>
.themeTop{
  position: fixed;
  /* display: left; */
  top:130px;
  /* left:0px; */
  width:845px;
  background: #fff;
  z-index:200;

}
.el-card:nth-child(3n+1) {
  clear: left;
}
.block{
  cursor: pointer;
}
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }
  a{
      text-decoration:none;
      color:#4b4b4b;
  }
    a:hover, a:link{
     
    }
  .content_s {
    width: 1200px;
    margin: 25px auto;
  }

  .img_s {
    width: 100%;
    border-radius: 6px;
  }

  .baomin {
    display: relative;
    width: 60%;
    height: 32px;
    border: white solid 2px;
    border-radius: 6px;
    text-align: center;
    color: white;
    position: absolute;
    top: 60%;
    left: 50%;
    margin-top: -50px;
    margin-left: -100px;
  }

  .fonts_bao {
  }

  .hello {
    color: rgb(58, 2, 2);
  }

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image{
  width: 108%;
  display: block;
  position: relative;
  top: -6px;
  left: -6px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .item h3 {
    color: #e85a50;
  }

  .icon_s {
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #eea01e;
    text-align: center;
    line-height: 30px;
    border-radius: 10px;
    margin-right: 15px;
    /* color:#fa5c00; */
    color: white;
  }

  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-row {
    margin-bottom: 0px;
  }

  .el-col {
    /* margin-right:30px; */
    border-radius: 4px;
  }
  /*轮播图*/
  .bg-purple-dark {
    background: #f7f7f7;
  }

  .bg-purple-light {
    background: #f7f7f7;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    padding: 30px 5%;
    min-width: 1200px;
  }

  .el-carousel__item h3 {
    margin: 0;
    position: absolute;
    bottom: 30px;
    line-height: 30px;
    font-size: 24px;
    color: #fff;
    padding: 0px 25px;
    font-weight: normal
  }
  .elter {
    width: 825px;
    height: 461px;
    border-radius: 6px;
    overflow:hidden;
  }


  .elter img {
    border-radius: 6px;
    width: 100%;
  }

  .content_l {
    width: 845px;
    float: left;
    padding-right: 20px;
    box-sizing: border-box
  }

  .content_r {
    width: 355px;
    float: left;
  }


  /*右侧2活动广告*/
  .r_topbanner img {
    display: block;
    border-radius: 6px;
    width: 100%;
  }

    .r_topbanner img:hover {
      opacity: 0.8;
      transform: rotate(0.2deg);
    }

    .r_topbanner img.img-1 {
      margin-bottom: 20px;
      cursor: pointer;
    }

  .r_topbanner {
    clear: both;
    margin-bottom: 20px
  }
  /*每日快讯*/
  .k-news {
    width: 353px;
    border: 1px solid #f1f1f1;
  }

    .k-news ul {
      margin: 0px;
      padding: 0px;
    }

      .k-news ul li {
        list-style: none;
        padding: 0px;
        font-size: 15px;
        line-height: 24px;
        color: #4b4b4b;
        text-align: left;
        padding-bottom: 25px !important;
      }

        .k-news ul li:hover {
          color: #bd0c16;
        }

        .k-news ul li .title, .k-news ul li .date {
          padding-left: 15px;
          display: block;
        }

        .k-news ul li .title {
          margin-top: -6px;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          cursor:pointer;
        }

        .k-news ul li .date {
          color: #a1a1a1;
          font-family: Arial
        }

    .k-news h2 {
      font-size: 18px;
      background-color: #f1f1f1;
      border-top: 5px solid #bd0c16;
      height: 43px;
      line-height: 43px;
      text-indent: 2px;
      color: #4b4b4b;
      margin: 0px !important;
      padding: 0px;
      width: 100%;
      font-weight: normal;
    }

  .k-elter {
    width: 320px;
    margin: 25px auto;
  }
.k-elter a:hover{
 
}
  .el-icon-alarm-clock {
    margin-right: 3px;
  }

  .el-timeline-item__node {
    background-color: #bd0c16;
    width: 10px;
    height: 10px;
    left: 0px;
  }

  .el-timeline-item__tail {
  }
  /*资讯列表*/
  .news-list {
    width: 100%;
    padding: 20px 0px;
  }

  .el-tabs {
    width: 100%;
  }

  .el-tabs__header {
    margin-bottom: 30px !important;
  }

  .el-card {
    margin: 16px 8px;
    cursor: pointer;
  }

    .el-card h3 {
      margin: 0px;
      padding: 10px 10px 3px;
      font-size: 14px;
      line-height: 24px;
      overflow:hidden;
      text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2;
      min-height: 48px;
    }

  .bq-tip {
    margin: 0px 0px 20px;
    padding: 10px 10px 0px;
    font-size: 12px;
    line-height: 18px;
    color: #bd0c16;
    display: block;
  }

  .el-button--primary {
    background-color: #ffffff;
    border: 1px solid #f1f1f1;
    font-size: 18px;
    color: #999;
    display: block;
    margin: 35px auto;
  }
  .el-button--primary:focus, .el-button--primary:hover{
   background-color:#bd0c16;
   color:#fff;
   border: 1px solid #bd0c16;
  }
  .el-loading-spinner .el-loading-text{
    color:#bd0c16!important;
  }
  /***/
  .r-gs1 {
    width: 100%;
    margin: 20px auto 13px;
  }

    .r-gs1 img {
      border-radius: 6px;
      display: block;
      margin-bottom:10px;
    }
  /*最新杂志*/

  .mag-list {
    width: 353px;
    border: 1px solid #f1f1f1;
    clear: both;
    margin: 20px auto 0px;
  }


    .mag-list h2 {
      font-size: 18px;
      background-color: #f1f1f1;
      border-top: 5px solid #bd0c16;
      height: 43px;
      line-height: 43px;
      text-indent: 2px;
      color: #4b4b4b;
      margin: 0px !important;
      padding: 0px;
      width: 100%;
      font-weight: normal;
    }

    .mag-list dl {
      width: 320px;
      margin: 25px auto 20px;
      clear: both;
      height: 225px;
      color: #999;
      line-height: 24px;
      /* padding-bottom: 15px; */
      /* border-bottom: 1px solid #f1f1f1; */
    }

      .mag-list dl dt {
        width: 173px;
        float: left;
        margin-right: 10px;
      }

      .mag-list dl dd p {
        margin: 0px;
      }

  .el-icon-alarm-clock {
    margin-right: 3px;
  }

  .mag-list .hh-img {
    display: block;
    margin: 0 auto 20px;
    border-radius: 6px;
    cursor: pointer;
  }

  .el-timeline-item__node {
    background-color: #999;
    width: 10px;
    height: 10px;
    left: 0px;
  }
  /*热点专题*/
  .hotrd-list {
    width: 353px;
    border: 1px solid #f1f1f1;
    clear: both;
    margin: 20px auto 0px;
  }


    .hotrd-list h2 {
      font-size: 18px;
      background-color: #f1f1f1;
      border-top: 5px solid #bd0c16;
      height: 43px;
      line-height: 43px;
      text-indent: 2px;
      color: #4b4b4b;
      margin: 0px !important;
      padding: 0px;
      width: 100%;
      font-weight: normal;
    }

  .hot-list {
    width: 320px;
    position: relative;
    margin: 25px 16px;
    cursor: pointer;
  }

    .hot-list img {
      width: 100%;
      border-radius: 6px;
      display: block;
    }

    .hot-list i {
      display: block;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: 0.5;
      position: absolute;
      left: 0px;
      top: 0px;
      border-radius: 6px;
    }

    .hot-list:hover i {
      opacity: 0
    }
    
    .hot-list p {
      position: absolute;
      width: 80%;
      height: 50px;
      top: 50%;
      left: 10%;
      margin-top: -25px;
      line-height: 25px;
      font-size: 18px;
      text-align: center;
      color: #fff;
      z-index: 100;
    }
    .hot-list:hover p {
      opacity: 0
    }

  .el-icon-alarm-clock, .el-icon-connection, .el-icon-reading, .el-icon-trophy {
    margin-right: 3px;
  }

  .el-button--default {
    background-color: #bd0c16;
    width: 118px;
    height: 40px;
    color: #ffffff;
    font-size: 16px;
    margin-top: 10px;
  }
  /*中企研究院*/
  .yyy-list {
    width: 353px;
    border: 1px solid #f1f1f1;
    clear: both;
    margin: 20px auto 0px;
  }

    .yyy-list h2 {
      font-size: 18px;
      background-color: #f1f1f1;
      border-top: 5px solid #bd0c16;
      height: 43px;
      line-height: 43px;
      text-indent: 2px;
      color: #4b4b4b;
      margin: 0px !important;
      padding: 0px;
      width: 100%;
      font-weight: normal;
    }

  .zk-list {
    width: 320px;
    position: relative;
    margin: 25px 16px;
    cursor: pointer;
  }

    .zk-list dl {
      width: 320px;
      margin: 20px auto 20px;
      clear: both;
      color: #999;
      line-height: 22px;
      height: 89px;
    }

      .zk-list dl dt {
        width: 133px;
        float: left;
        margin-right: 10px;
      }

      .zk-list dl img {
        border-radius: 6px;
        width:100%;
      }

      .zk-list dl dd p {
        margin: 0px;
        font-size: 14px;
        line-height: 22px;
      }
  /*品牌活动*/
  .pinpai-list {
    width: 353px;
    border: 1px solid #f1f1f1;
    clear: both;
    margin: 20px auto 0px;
  }

    .pinpai-list h2 {
      font-size: 18px;
      background-color: #f1f1f1;
      border-top: 5px solid #bd0c16;
      height: 43px;
      line-height: 43px;
      text-indent: 2px;
      color: #4b4b4b;
      margin: 0px !important;
      padding: 0px;
      width: 100%;
      font-weight: normal;
    }

  .pp-imglist {
    width: 320px;
    position: relative;
    margin: 25px 16px;
    cursor: pointer;
  }

    .pp-imglist img {
      display: block;
      margin: 0px auto 15px;
    }

  .tougao {
    width: 100%;
    margin: 20px auto;
  }

    .tougao img {
      width: 100%;
      border-radius: 6px;
    }

  .el-card {
    transition: 3s;
  }

  .el-card:hover .shake {
    cursor: pointer;
    transform: translateY(8px);
    transition: all .3s ease-in;
  }
  .gg-banner {
      width:100%;
      padding:0px 8px;
      box-sizing:border-box;
  }
  .gg-banner img{
      width:100%;
  }
  .new-img {
    height: 120px;
    overflow: hidden;
    position: relative;
  }
  .showall_realtime{
    cursor: pointer;
    float: right;
    margin-right:12px;
    font-size: 12px;
    /* font-weight:bold; */
  }

  .jian-tip{
  position: absolute;
  right:2px;
  top: 2px;
  font-size: 10px;
  font-family: Avenir,Helvetica,Arial,sans-serif;
  width: 26px;
  height: 22px;
  line-height: 22px;
  color:#f1f41e;
  background: #db2916;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 12px;
  z-index: 100;
  text-align: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/Show.vue